import { render } from "./StarsIcon.vue?vue&type=template&id=011c965a"
import script from "./StarsIcon.vue?vue&type=script&lang=ts"
export * from "./StarsIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script